import * as React from 'react';

import { newWorkbookButton } from '~src/app/spaces/SiteUserSpace/SiteSpaceHeaderButtons';

import { ConnectedExplorer } from '../app/spaces/Explorer/ConnectedExplorer';
import { CreateContentButtonLocations } from '../app/spaces/Explorer/CreateContent/CreateContentButton';
import { PropsForExplorerToolbar } from '../app/spaces/Explorer/Explorer';
import { ConnectedQueryParamUpdateProvider } from '../app/spaces/RouterHelpers/QueryParamUpdateProvider';
import { ConnectedSpaceInfoProvider } from '../app/spaces/RouterHelpers/SpaceInfoProvider';
import { ConnectedExplorerSubspaceInitializer } from '../app/spaces/SpaceConfig/ExplorerSubspaceInitializer';
import { createContentButton } from '../app/spaces/SubspaceHelpers';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../app/state/SpaceInfo';
import { ExplorableItemDefinition } from '../contentDefinitionInterfaces/ContentDefinitionsTypes';
import { SpaceContainerStyles } from '../style/SpaceContainerStyles';
import { FeatureFlags } from '../ts/FeatureFlags';
import { IContentType } from '../ts/models/ContentTypes';
import { CatalogContentType } from './CatalogContentType';

export interface CatalogBrowserSubspaceExplorerProps {
  readonly subspaceName: CatalogContentType;
  readonly routeLocationSearch: string;
  readonly contentDefinition: ExplorableItemDefinition;
  readonly contentType: IContentType;
}

export function CatalogBrowserSubspaceExplorer(props: CatalogBrowserSubspaceExplorerProps): JSX.Element {

  const queryUpdaterProps = {
    routeLocationPath: '',
    routeLocationSearch: props.routeLocationSearch,
    shouldUpdateContentTypes: true,
    shouldUpdateFilters: true,
    shouldUpdateBreadcrumbs: false, // Breadcrumbs are updated by the DC3 code
    shouldUpdateSort: true
  };

  const spaceInfo: SpaceInfo = {
    item: SpaceItemForNonEntitySpace,
    spaceType: 'catalog',
    subspaceName: props.subspaceName,
  };

  const baseToolbarProps: PropsForExplorerToolbar = {
    supportFilterPanel: props.contentType.canShowFilterPanel,
    toolbarVisibility: 'enabled',
  };

  const createButton = FeatureFlags.flowsFromCatalogEnabled ?
      createContentButton({ location: CreateContentButtonLocations.ExternalAssets, spaceType: 'externalAssets'}) : newWorkbookButton();

  return (
    <div className={SpaceContainerStyles.SubplaceArea}>
      <ConnectedSpaceInfoProvider spaceInfo={spaceInfo}>
        <ConnectedQueryParamUpdateProvider {...queryUpdaterProps}>
          <ConnectedExplorerSubspaceInitializer routeLocationSearch={props.routeLocationSearch} spaceInfo={spaceInfo}>
            <ConnectedExplorer
              supportedDisplayModes={props.contentDefinition.supportedDisplayModes}
              toolbarProps={FeatureFlags.newWorkbookFromCatalog
                ? {...baseToolbarProps, toolbarContentSpecificControls: { beginning: createButton }}
                : baseToolbarProps}
            />
          </ConnectedExplorerSubspaceInitializer>
        </ConnectedQueryParamUpdateProvider>
      </ConnectedSpaceInfoProvider>
    </div>
  );
}
